import BaseCard from './BaseCard';
import TransformComponent from '../../../Component/Transform';
import CardComponent from '../../../Component/Level/Card';

export default class JokerPreBoosterCard extends BaseCard {
    public onCreate(params: any): void {
        super.onCreate({
            ...params,
            cardFrontTexture: 'blank',
            dragonbonesName: 'booster_card_wildcard',
            armatureName: 'armatureName',
        });

        const armature = this.getArmature();
        const armatureTransform = armature.getComponent(TransformComponent);
        armatureTransform.scale.set(0.55);
        armatureTransform.y = 16;

        this.getComponent(CardComponent).skipStackAlign = true;
    }
}
